var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.417,
    height: 83.417,
    viewBox: "0 0 83.417 83.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-coins",
    "data-name": "Icon awesome-coins",
    d: "M0,66.033V72.99c0,5.751,14.012,10.427,31.282,10.427S62.563,78.742,62.563,72.99V66.033c-6.729,4.741-19.03,6.957-31.282,6.957S6.729,70.775,0,66.033ZM52.136,20.854c17.27,0,31.282-4.676,31.282-10.427S69.406,0,52.136,0,20.854,4.676,20.854,10.427,34.866,20.854,52.136,20.854ZM0,48.943V57.35C0,63.1,14.012,67.777,31.282,67.777S62.563,63.1,62.563,57.35V48.943c-6.729,5.539-19.046,8.407-31.282,8.407S6.729,54.482,0,48.943Zm67.777,1.792c9.336-1.808,15.641-5.165,15.641-9.026V34.752c-3.78,2.672-9.336,4.5-15.641,5.621Zm-36.5-24.667C14.012,26.068,0,31.9,0,39.1S14.012,52.136,31.282,52.136,62.563,46.3,62.563,39.1,48.552,26.068,31.282,26.068Zm35.729,9.173c9.775-1.76,16.407-5.214,16.407-9.173V19.111C77.634,23.2,67.7,25.4,57.235,25.921,62.042,28.251,65.577,31.379,67.011,35.241Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeCoins);
export default __webpack_public_path__ + "static/media/Icon_awesome-coins.eed0e2fa6e8568d49c2d83963aa99c1a.svg";
export { ForwardRef as ReactComponent };